import { MONAIBundle } from "./types";


export const MONAI_BUNDLES: MONAIBundle[] = [
  // Segmentation Bundles
  {
    id: 'spleen_ct_segmentation',
    name: 'spleen_ct_segmentation',
    displayName: 'Spleen CT Segmentation',
    task: 'segmentation',
    modality: 'CT',
    description: 'Spleen segmentation model for CT scans using UNet architecture',
    architecture: 'UNet',
    inputSize: '96x96x96',
    vramRequired: 8,
    diceScore: 0.963,
    ngcPath: 'nvidia/monailabel/spleen_ct_segmentation',
    version: '0.5.4',
    outputClasses: 2,
    outputClassNames: ['Background', 'Spleen'],
    pretrainedDataset: 'Medical Segmentation Decathlon (Task09)',
    useCases: ['Abdominal CT analysis', 'Organ volumetry', 'Surgical planning', 'Radiation therapy'],
    strengths: ['High accuracy on spleen segmentation', 'Fast inference time', 'Low VRAM requirement', 'Robust to contrast variations'],
    limitations: ['Single organ only', 'Requires contrast-enhanced CT', 'May struggle with splenomegaly'],
    supportedAugmentations: ['RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandShiftIntensity', 'RandGaussianNoise'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/1809.10486',
  },
  {
    id: 'pancreas_ct_dints',
    name: 'pancreas_ct_dints_segmentation',
    displayName: 'Pancreas CT DiNTS',
    task: 'segmentation',
    modality: 'CT',
    description: 'Pancreas and tumor segmentation using DiNTS architecture',
    architecture: 'DiNTS',
    inputSize: '96x96x96',
    vramRequired: 16,
    diceScore: 0.842,
    ngcPath: 'nvidia/monailabel/pancreas_ct_dints_segmentation',
    version: '0.4.8',
    outputClasses: 3,
    outputClassNames: ['Background', 'Pancreas', 'Tumor'],
    pretrainedDataset: 'Medical Segmentation Decathlon (Task07)',
    useCases: ['Pancreatic cancer detection', 'Treatment planning', 'Disease monitoring', 'Surgical navigation'],
    strengths: ['Neural architecture search optimized', 'Good tumor detection', 'Handles anatomical variations'],
    limitations: ['Higher VRAM requirement', 'Complex architecture', 'Longer training time'],
    supportedAugmentations: ['RandCropByPosNegLabel', 'RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandAffine'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2108.13807',
  },
  {
    id: 'lung_nodule_ct_detection',
    name: 'lung_nodule_ct_detection',
    displayName: 'Lung Nodule Detection',
    task: 'detection',
    modality: 'CT',
    description: 'Lung nodule detection in CT scans using RetinaNet',
    architecture: 'RetinaNet',
    inputSize: '512x512x128',
    vramRequired: 12,
    auc: 0.945,
    ngcPath: 'nvidia/monailabel/lung_nodule_ct_detection',
    version: '0.3.2',
    outputClasses: 2,
    outputClassNames: ['Background', 'Nodule'],
    pretrainedDataset: 'LUNA16 Challenge Dataset',
    useCases: ['Lung cancer screening', 'Nodule tracking', 'Early detection', 'Radiology workflow'],
    strengths: ['High sensitivity for small nodules', 'Fast screening', '3D detection capability', 'Low false positive rate'],
    limitations: ['Requires thin-slice CT', 'May miss ground-glass nodules', 'Sensitive to motion artifacts'],
    supportedAugmentations: ['RandFlip', 'RandRotate90', 'RandZoom', 'RandGaussianNoise', 'RandAdjustContrast'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/1708.02002',
  },
  {
    id: 'swin_unetr_btcv',
    name: 'swin_unetr_btcv_segmentation',
    displayName: 'Swin UNETR BTCV',
    task: 'segmentation',
    modality: 'CT',
    description: 'Multi-organ segmentation using Swin UNETR on BTCV dataset',
    architecture: 'SwinUNETR',
    inputSize: '96x96x96',
    vramRequired: 24,
    diceScore: 0.918,
    ngcPath: 'nvidia/monailabel/swin_unetr_btcv_segmentation',
    version: '0.6.0',
    outputClasses: 14,
    outputClassNames: ['Background', 'Spleen', 'Right Kidney', 'Left Kidney', 'Gallbladder', 'Esophagus', 'Liver', 'Stomach', 'Aorta', 'IVC', 'Portal Vein', 'Pancreas', 'Right Adrenal', 'Left Adrenal'],
    pretrainedDataset: 'BTCV Multi-organ Segmentation Challenge',
    useCases: ['Multi-organ analysis', 'Comprehensive CT review', 'Anatomy education', 'Body composition analysis'],
    strengths: ['State-of-the-art transformer architecture', 'Multi-organ capability', 'Self-attention mechanism', 'Good generalization'],
    limitations: ['High VRAM requirement', 'Longer inference time', 'Requires powerful GPU'],
    supportedAugmentations: ['RandCropByPosNegLabel', 'RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandShiftIntensity'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2201.01266',
  },
  {
    id: 'whole_body_ct_seg',
    name: 'whole_body_ct_segmentation',
    displayName: 'Whole Body CT Segmentation',
    task: 'segmentation',
    modality: 'CT',
    description: '104-class whole body CT segmentation using SegResNet',
    architecture: 'SegResNet',
    inputSize: '96x96x96',
    vramRequired: 32,
    diceScore: 0.892,
    ngcPath: 'nvidia/monailabel/whole_body_ct_segmentation',
    version: '0.5.0',
    outputClasses: 104,
    outputClassNames: ['Background', 'Spleen', 'Kidney R', 'Kidney L', 'Gallbladder', 'Liver', 'Stomach', 'Pancreas', 'Adrenal R', 'Adrenal L', 'Lung Upper L', 'Lung Lower L', 'Lung Upper R', 'Lung Middle R', 'Lung Lower R', 'Esophagus', 'Trachea', 'Thyroid', 'Small Bowel', 'Duodenum', 'Colon', 'Urinary Bladder', 'Prostate', 'Kidney Cyst R', 'Kidney Cyst L', '...and 79 more'],
    pretrainedDataset: 'TotalSegmentator Dataset',
    useCases: ['Comprehensive body analysis', 'Radiation therapy planning', 'Body composition', 'Multi-organ quantification'],
    strengths: ['Most comprehensive segmentation', '104 anatomical structures', 'Single model for whole body', 'Research-grade accuracy'],
    limitations: ['Very high VRAM requirement', 'Longer processing time', 'Requires full-body CT'],
    supportedAugmentations: ['RandCropByPosNegLabel', 'RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandAffine', 'RandGaussianNoise'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2208.05868',
  },
  {
    id: 'breast_density_class',
    name: 'breast_density_classification',
    displayName: 'Breast Density Classification',
    task: 'classification',
    modality: 'X-Ray',
    description: 'Mammography breast density classification (BI-RADS)',
    architecture: 'DenseNet121',
    inputSize: '224x224',
    vramRequired: 4,
    accuracy: 0.891,
    ngcPath: 'nvidia/monailabel/breast_density_classification',
    version: '0.2.1',
    outputClasses: 4,
    outputClassNames: ['BI-RADS A (Fatty)', 'BI-RADS B (Scattered)', 'BI-RADS C (Heterogeneous)', 'BI-RADS D (Extremely Dense)'],
    pretrainedDataset: 'CBIS-DDSM + VinDr-Mammo',
    useCases: ['Breast cancer screening', 'Risk assessment', 'Supplemental screening recommendation', 'Quality assurance'],
    strengths: ['BI-RADS compliant', 'Low computational cost', 'Fast inference', 'Good clinical correlation'],
    limitations: ['2D mammography only', 'Vendor-specific variations', 'Requires proper positioning'],
    supportedAugmentations: ['RandRotate', 'RandFlip', 'RandZoom', 'RandAdjustContrast', 'RandGaussianNoise'],
    license: 'Apache 2.0',
  },
  {
    id: 'pathology_nuclei_seg',
    name: 'pathology_nuclei_segmentation_he',
    displayName: 'Pathology Nuclei Segmentation',
    task: 'segmentation',
    modality: 'Pathology',
    description: 'Nuclear segmentation in H&E stained pathology images',
    architecture: 'HoVerNet',
    inputSize: '256x256',
    vramRequired: 8,
    diceScore: 0.876,
    ngcPath: 'nvidia/monailabel/pathology_nuclei_segmentation_he',
    version: '0.3.5',
    outputClasses: 6,
    outputClassNames: ['Background', 'Neoplastic', 'Inflammatory', 'Connective', 'Dead', 'Epithelial'],
    pretrainedDataset: 'PanNuke + CoNSeP Dataset',
    useCases: ['Digital pathology analysis', 'Cancer grading', 'Cell counting', 'Tumor microenvironment analysis'],
    strengths: ['Instance segmentation capable', 'Multi-class nuclei', 'Handles overlapping cells', 'Stain-normalized'],
    limitations: ['H&E staining only', 'Requires high magnification', 'Computationally intensive for WSI'],
    supportedAugmentations: ['RandRotate', 'RandFlip', 'ColorJitter', 'RandGaussianNoise', 'RandAffine'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/1812.06499',
  },
  {
    id: 'cardiac_mri_seg',
    name: 'cardiac_mri_segmentation',
    displayName: 'Cardiac MRI Segmentation',
    task: 'segmentation',
    modality: 'MRI',
    description: 'Cardiac structure segmentation in MRI (LV, RV, MYO)',
    architecture: 'UNETR',
    inputSize: '96x96x96',
    vramRequired: 12,
    diceScore: 0.934,
    ngcPath: 'nvidia/monailabel/cardiac_mri_segmentation',
    version: '0.4.2',
    outputClasses: 4,
    outputClassNames: ['Background', 'Left Ventricle (LV)', 'Right Ventricle (RV)', 'Myocardium (MYO)'],
    pretrainedDataset: 'ACDC Challenge Dataset',
    useCases: ['Cardiac function assessment', 'Ejection fraction calculation', 'Cardiomyopathy analysis', 'Treatment monitoring'],
    strengths: ['Transformer-based architecture', 'Accurate boundary detection', 'Handles motion artifacts', 'Multi-phase support'],
    limitations: ['Cine MRI required', 'Short-axis views only', 'May struggle with severe pathology'],
    supportedAugmentations: ['RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandAffine', 'RandGaussianNoise'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2103.10504',
  },
  {
    id: 'prostate_mri_anatomy',
    name: 'prostate_mri_anatomy_segmentation',
    displayName: 'Prostate MRI Anatomy',
    task: 'segmentation',
    modality: 'MRI',
    description: 'Prostate zonal anatomy segmentation in MRI',
    architecture: 'nnUNet',
    inputSize: '320x320x32',
    vramRequired: 16,
    diceScore: 0.887,
    ngcPath: 'nvidia/monailabel/prostate_mri_anatomy',
    version: '0.3.8',
    outputClasses: 3,
    outputClassNames: ['Background', 'Peripheral Zone (PZ)', 'Transition Zone (TZ)'],
    pretrainedDataset: 'ProstateX + PI-CAI Challenge',
    useCases: ['Prostate cancer detection', 'Biopsy planning', 'Active surveillance', 'Treatment planning'],
    strengths: ['nnUNet auto-configuration', 'Zonal anatomy support', 'Multi-parametric MRI', 'Robust to protocol variations'],
    limitations: ['T2-weighted MRI required', 'Endorectal coil recommended', 'Learning curve for annotation'],
    supportedAugmentations: ['RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandElasticDeformation', 'RandGaussianNoise'],
    license: 'Apache 2.0',
  },
  {
    id: 'chest_xray_class',
    name: 'chest_xray_classification',
    displayName: 'Chest X-Ray Classification',
    task: 'classification',
    modality: 'X-Ray',
    description: 'Multi-label chest X-ray finding classification',
    architecture: 'EfficientNetB4',
    inputSize: '384x384',
    vramRequired: 6,
    auc: 0.892,
    ngcPath: 'nvidia/monailabel/chest_xray_classification',
    version: '0.4.0',
    outputClasses: 14,
    outputClassNames: ['Atelectasis', 'Cardiomegaly', 'Consolidation', 'Edema', 'Effusion', 'Emphysema', 'Fibrosis', 'Hernia', 'Infiltration', 'Mass', 'Nodule', 'Pleural Thickening', 'Pneumonia', 'Pneumothorax'],
    pretrainedDataset: 'ChestX-ray14 (NIH)',
    useCases: ['Chest X-ray screening', 'Radiology workflow', 'Triage prioritization', 'Second opinion'],
    strengths: ['Multi-label classification', 'Fast inference', 'Covers common findings', 'Good sensitivity'],
    limitations: ['2D frontal view only', 'Label noise in dataset', 'May miss subtle findings'],
    supportedAugmentations: ['RandRotate', 'RandFlip', 'RandZoom', 'RandAdjustContrast', 'RandHistogramShift'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/1705.02315',
  },
  {
    id: 'retinal_oct_class',
    name: 'retinal_oct_classification',
    displayName: 'Retinal OCT Classification',
    task: 'classification',
    modality: 'Fundus',
    description: 'Retinal disease classification from OCT images',
    architecture: 'ResNet50',
    inputSize: '224x224',
    vramRequired: 4,
    accuracy: 0.967,
    ngcPath: 'nvidia/monailabel/retinal_oct_classification',
    version: '0.2.5',
    outputClasses: 4,
    outputClassNames: ['Normal', 'CNV (Choroidal Neovascularization)', 'DME (Diabetic Macular Edema)', 'Drusen'],
    pretrainedDataset: 'Kermany OCT Dataset',
    useCases: ['AMD screening', 'Diabetic retinopathy assessment', 'Ophthalmology workflow', 'Treatment monitoring'],
    strengths: ['High accuracy', 'Fast inference', 'Low resource requirement', 'Clinically validated'],
    limitations: ['Limited to 4 classes', 'OCT-specific', 'May need device calibration'],
    supportedAugmentations: ['RandRotate', 'RandFlip', 'RandZoom', 'RandGaussianNoise', 'RandAdjustContrast'],
    license: 'Apache 2.0',
    paperReference: 'https://www.cell.com/cell/fulltext/S0092-8674(18)30154-5',
  },
  {
    id: 'liver_tumor_seg',
    name: 'liver_tumor_segmentation',
    displayName: 'Liver Tumor Segmentation',
    task: 'segmentation',
    modality: 'CT',
    description: 'Liver and tumor segmentation in CT scans',
    architecture: 'UNet',
    inputSize: '128x128x128',
    vramRequired: 12,
    diceScore: 0.923,
    ngcPath: 'nvidia/monailabel/liver_tumor_segmentation',
    version: '0.5.1',
    outputClasses: 3,
    outputClassNames: ['Background', 'Liver', 'Tumor'],
    pretrainedDataset: 'LiTS Challenge Dataset',
    useCases: ['Liver cancer assessment', 'Surgical planning', 'Treatment response', 'RECIST measurements'],
    strengths: ['Simultaneous liver and tumor', 'Good tumor boundary', 'Handles multiple lesions', 'Clinical-grade accuracy'],
    limitations: ['Contrast-enhanced CT required', 'May miss small lesions', 'Portal venous phase preferred'],
    supportedAugmentations: ['RandCropByPosNegLabel', 'RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandGaussianNoise'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/1702.05970',
  },
  {
    id: 'vista3d',
    name: 'vista3d',
    displayName: 'VISTA-3D Foundation',
    task: 'segmentation',
    modality: 'CT',
    description: 'Foundation model for 3D medical image segmentation (127 classes)',
    architecture: 'SegResNet',
    inputSize: '128x128x128',
    vramRequired: 48,
    diceScore: 0.901,
    ngcPath: 'nvidia/monailabel/vista3d',
    version: '0.2.0',
    outputClasses: 127,
    outputClassNames: ['Background', 'Spleen', 'Kidney R', 'Kidney L', 'Gallbladder', 'Liver', 'Stomach', 'Pancreas', 'Adrenal R', 'Adrenal L', 'Lung Upper L', 'Lung Lower L', 'Lung Upper R', 'Lung Middle R', 'Lung Lower R', 'Heart', 'Aorta', 'IVC', 'Portal Vein', 'Hepatic Vein', 'Pulmonary Artery', 'Bladder', 'Prostate/Uterus', 'Rectum', 'Small Bowel', '...and 102 more anatomical structures'],
    pretrainedDataset: 'Multi-dataset (TotalSegmentator + BTCV + AMOS + more)',
    useCases: ['Universal 3D segmentation', 'Zero-shot transfer', 'Foundation model fine-tuning', 'Research applications'],
    strengths: ['Foundation model capability', 'Interactive segmentation', 'Point-prompt support', 'Zero-shot learning'],
    limitations: ['Very high VRAM requirement', 'Requires A100/H100 GPU', 'Longer inference time'],
    supportedAugmentations: ['RandCropByPosNegLabel', 'RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandAffine', 'RandGaussianNoise'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2406.05285',
  },
  {
    id: 'dermoscopy_class',
    name: 'dermoscopy_classification',
    displayName: 'Dermoscopy Classification',
    task: 'classification',
    modality: 'Dermoscopy',
    description: 'Skin lesion classification from dermoscopy images',
    architecture: 'EfficientNetB3',
    inputSize: '300x300',
    vramRequired: 4,
    accuracy: 0.912,
    ngcPath: 'nvidia/monailabel/dermoscopy_classification',
    version: '0.3.0',
    outputClasses: 7,
    outputClassNames: ['Melanoma', 'Melanocytic Nevus', 'Basal Cell Carcinoma', 'Actinic Keratosis', 'Benign Keratosis', 'Dermatofibroma', 'Vascular Lesion'],
    pretrainedDataset: 'ISIC 2019 Challenge',
    useCases: ['Skin cancer screening', 'Dermatology workflow', 'Teledermatology', 'Clinical decision support'],
    strengths: ['Covers 7 major categories', 'Good melanoma detection', 'Fast inference', 'Mobile-deployable'],
    limitations: ['Dermoscopy images only', 'Requires proper illumination', 'May need calibration'],
    supportedAugmentations: ['RandRotate', 'RandFlip', 'RandZoom', 'ColorJitter', 'RandGaussianNoise', 'RandAdjustContrast'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/1902.03368',
  },
  {
    id: 'kidney_ct_seg',
    name: 'kidney_ct_segmentation',
    displayName: 'Kidney CT Segmentation',
    task: 'segmentation',
    modality: 'CT',
    description: 'Kidney and tumor segmentation from CT scans',
    architecture: 'nnUNet',
    inputSize: '96x96x96',
    vramRequired: 16,
    diceScore: 0.945,
    ngcPath: 'nvidia/monailabel/kidney_ct_segmentation',
    version: '0.4.5',
    outputClasses: 4,
    outputClassNames: ['Background', 'Kidney', 'Tumor', 'Cyst'],
    pretrainedDataset: 'KiTS21 Challenge Dataset',
    useCases: ['Renal cell carcinoma assessment', 'Surgical planning', 'Cyst vs tumor differentiation', 'Nephron-sparing surgery'],
    strengths: ['nnUNet-based high accuracy', 'Cyst differentiation', 'Both kidneys segmented', 'Clinical validation'],
    limitations: ['Contrast-enhanced CT required', 'May struggle with horseshoe kidney', 'Requires nephrographic phase'],
    supportedAugmentations: ['RandCropByPosNegLabel', 'RandRotate90', 'RandFlip', 'RandScaleIntensity', 'RandElasticDeformation'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/1912.01054',
  },
];

